import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadQidDatapoints,
    DeleteQidModelSafetyFunction,
    setQidModelDeleteSafetyFunction,
    setQidModelReloadList,
    setQidDatapointReloadList,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
    Loader,
} from "client/components"


export const ConfirmDeleteSafetyFunction = () => {
    const product = useSelector((state: StoreType) => state.qidProduct.productView)
    const safetyFunction = useSelector((state: StoreType) => state.qidModel.deleteSafetyFunction)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [datapoints, setDatapoints] = useState<number>(0)
    const [loadState, setLoadState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    useEffect(() => {
        if (!safetyFunction) return
        setLoadState(PENDING)
        LoadQidDatapoints({
            safetyFunctionId: safetyFunction.id,
        }).then((res) => {
            setDatapoints(res.length)
            setLoadState(IDLE)
        })
    }, [safetyFunction])

    const onCancel = () => {
        dispatch(setQidModelDeleteSafetyFunction(null))
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)
        DeleteQidModelSafetyFunction(safetyFunction.id, safetyFunction.modelId, product.id).then(() => {
            setDeleteState(IDLE)

            dispatch(setQidModelDeleteSafetyFunction(null))

            dispatch(setQidModelReloadList(false))
            dispatch(setQidDatapointReloadList(false))
            setTimeout(() => {
                dispatch(setQidModelReloadList(true))
                dispatch(setQidDatapointReloadList(true))
            }, 0)
        })
    }

    return (
        <ConfirmWrapper show={!!safetyFunction} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{safetyFunction ? safetyFunction.name : ""}</ConfirmTitle>
                <ConfirmDescription>
                    {
                        loadState === PENDING
                            ? <Loader />
                            : (datapoints > 0 ? lang.deleteSafetyFunctionDatapointsConfirm : lang.deleteSafetyFunctionConfirm)
                    }
                </ConfirmDescription>

                <ConfirmBottom>
                    <Button variant="success" row disabled={deleteState === PENDING} onClick={onConfirmDelete}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                    <Button row onClick={onCancel}>
                        {lang.cancel}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDeleteSafetyFunction
